import { render, staticRenderFns } from "./AllowancesPlanDetailsInfo.vue?vue&type=template&id=23df14b1&scoped=true&"
import script from "./AllowancesPlanDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDetailsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df14b1",
  null
  
)

export default component.exports